import { Component } from '@angular/core';

@Component({
  selector: 'allas-tipos-de-filtros-que-cambiamos',
  imports: [],
  template: `
    <section class="flex flex-col gap-2 mt-12">
      <h1 class="text-2xl xl:text-4xl font-bold fs-condensed text-center">
        TIPOS DE FILTROS QUE CAMBIAMOS
      </h1>
      <p class="text-center text-xs xl:text-base">
        Ofrecemos servicio completo de cambio para filtros de aire y cabina
        <br class="hidden xl:block" />
        de tu vehículo, garantizando el mejor rendimiento y protección.
      </p>

      <main class="grid grid-cols-1 xl:grid-cols-2 gap-4 mt-6 xl:mt-0">
        <article
          class="flex flex-col relative min-h-[300px] xl:min-h-[400px] w-full"
        >
          <div class="bg-white h-[25%]"></div>
          <div class="bg-[#f3f3f5] h-[75%]"></div>
          <div
            class="absolute bottom-0 left-0 w-full flex flex-col gap-2 m-2 mb-12"
          >
            <div class="flex items-center justify-center mb-6 xl:mb-12">
              <img
                src="/images/services/cambio-filtros/filtro-aire.webp"
                alt="Filtro de aire"
                class="w-auto h-32 xl:h-60"
              />
            </div>
            <h3 class="text-xl xl:text-2xl font-bold fs-condensed text-center">
              FILTRO DE AIRE
            </h3>
            <p class="text-xs xl:text-sm text-center">
              Protege tu motor del polvo y partículas, mejorando la combustión.
            </p>
          </div>
        </article>
        <article
          class="flex flex-col relative min-h-[300px] xl:min-h-[400px] w-full"
        >
          <div class="bg-white h-[25%]"></div>
          <div class="bg-[#f3f3f5] h-[75%]"></div>
          <div
            class="absolute bottom-0 left-0 w-full flex flex-col gap-2 m-2 mb-12"
          >
            <div class="flex items-center justify-center mb-6 xl:mb-12">
              <img
                src="/images/services/cambio-filtros/filtro-cabina.webp"
                alt="Filtro de cabina"
                class="w-auto h-32 xl:h-60"
              />
            </div>
            <h3 class="text-xl xl:text-2xl font-bold fs-condensed text-center">
              FILTRO DE CABINA
            </h3>
            <p class="text-xs xl:text-sm text-center">
              Purifica el aire del habitáculo para tu comodidad y salud.
            </p>
          </div>
        </article>
      </main>
    </section>
  `,
})
export class TiposDeFiltrosQueCambiamos {}
